import { routes } from './routes'
import { vsName as userProfileModuleName } from '../application/userProfileModule'

export const vsModuleName = 'SlotTrak.Machines.Progressives'

var mod = angular.module(vsModuleName, ['records', userProfileModuleName])

mod
  .config(routes)

export default mod.name